<div class="modal">
  <div class="modal-overlay" (click)="close()"></div>

  <div class="modal-dialog w-100" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <span class="modal-title" i18n="@@DialogCookieNoticeHeader">Cookie notice and settings</span>
        <span class="me-auto"></span>
        <i class="btn btn-danger bi bi-x-lg" (click)="close()"></i>
      </div>

      <div class="modal-body m-3">
        <span class="fw-bold" i18n="@@DialogCookieNoticeSubTitle">Necessary cookies</span>
        <div i18n="@@DialogCookieNoticeMessage1">These cookies serve the technically correct operation of our website and cannot be deactivated in your systems.</div>
        <div i18n="@@DialogCookieNoticeMessage2">These cookies are not used to collect information about you for other purposes such as marketing or analysis.</div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-success" i18n="@@DialogCookieNoticeAgreeButton" (click)="agree()">I agree</button>
        <button type="button" class="btn btn-warning" data-bs-dismiss="modal" i18n="@@DialogCookieNoticeCancelButton" (click)="close()">Cancel</button>
      </div>
    </div>
  </div>
</div>
